import { useHistory, useParams } from 'react-router-dom'
import api from '../../api/axios/foka'
import { fail } from '../toast/Toast'
import NoneAnchor from '../../components/NoneAnchor'
import PropTypes from 'prop-types'

export const BizChannelLink = ({ id, name }) => {
  const history = useHistory()
  const { accountId } = useParams()
  const handleClick = async () => {
    await api.ad
      .getBizChannel(id)
      .then(() => {
        history.push(`/${accountId}/channels/${id}`)
      })
      .catch(() => {
        fail('삭제된 비즈채널입니다.')
        history.push(`/${accountId}/channels`)
      })
  }
  return (
    <NoneAnchor onClick={handleClick} className="txt_limit fc_emph">
      {name}
    </NoneAnchor>
  )
}
BizChannelLink.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
}

export const CreativeLink = ({ id, name }) => {
  const history = useHistory()
  const { accountId } = useParams()
  const handleClick = async () => {
    await api.creative
      .getCreative(id)
      .then(() => {
        history.push(`/${accountId}/creatives/${id}`)
      })
      .catch(() => {
        fail('삭제된 소재입니다.')
        history.push(`/${accountId}/creatives`)
      })
  }
  return (
    <NoneAnchor onClick={handleClick} className="txt_limit fc_emph">
      {name}
    </NoneAnchor>
  )
}
CreativeLink.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
}

export const RestrictionIpLink = ({ id, name }) => {
  const history = useHistory()
  const { accountId } = useParams()
  const handleClick = async () => {
    await api.restrictionIp
      .getRestrictionIp(id)
      .then(() => {
        history.push(`/${accountId}/restrict-ip`)
      })
      .catch(() => {
        fail('삭제된 IP입니다.')
        history.push(`/${accountId}/restrict-ip`)
      })
  }
  return (
    <NoneAnchor onClick={handleClick} className="txt_limit fc_emph">
      {name}
    </NoneAnchor>
  )
}
RestrictionIpLink.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
}
